module.exports = __webpack_public_path__ + "img/launchpad.11c1dc6b.svg";